import { Box, Button } from '@mui/material';
import React from 'react';
import "./produzioni.scss";
import { ReactComponent as Joker } from "../../assets/dashboardIcons/JokerIcon.svg";
import { triggerFormSubmit } from '../../features/produzioniFormData/produzioniFormDataSlice';
import { useDispatch } from 'react-redux';

const Header = ({ data, activeStep, setActiveStep }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(triggerFormSubmit()); 
  };


  // const handleNextClick = () => {
  //   if (activeStep < 8) {
  //     setActiveStep(activeStep + 1);
  //   }
  // };

  return (
    <Box className="commonHeader">
      <Joker className='commonHeader__icon' />
      <h2 className='commonHeader__title'>
        {data.title}
      </h2>
      <Box className="commonHeader__btnPart">
        <p color="textSecondary">
          {data.description}
        </p>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClick}
        >
          {data.buttonText}
        </Button>
      </Box>
    </Box>
  );
};

export default Header;
